// Copyright (c) StrangeBee 2024

import React, { ReactElement } from 'react';
import { CardContentProps } from '../CardContentType';
import StreamCard from '@Organisms/LiveStreamData/StreamCard/StreamCard';
import { PropRender } from '@Organisms/LiveStreamData/PropRenderer/PropRenderer';
import { ICONS } from '@Constants/iconsApp';

import './CaseTemplateContent.scss';
import { useLocalMessage } from '@Helpers/locale';

export const CaseTemplateContent = ({ data: caseTemplate, base }: CardContentProps): ReactElement => {
    const local = useLocalMessage();

    const { name, displayName, _id: caseTemplateId } = caseTemplate || {};

    const title = displayName && displayName.trim() !== '' ? displayName : name;

    const { action, details, context } = base;

    const detailsCreated = {
        description: details?.description,
    };

    return (
        <StreamCard
            icon={<ICONS.CaseTemplateIcon />}
            title={title ? title : local('stream.card.casetemplate.delete')}
            base={base}
            parent={action === 'delete' ? context : null} // Context does not include the parent organization when the action is create or update
            information="caseTemplate"
        >
            {action === 'create' &&
                Object.entries(detailsCreated).map(([key, value]) => (
                    <PropRender key={caseTemplateId + key} prop={key} value={value} type="caseTemplate" />
                ))}
            {action === 'update' &&
                Object.entries(details).map(([key, value]) => (
                    <PropRender key={caseTemplateId + key} prop={key} value={value} type="caseTemplate" />
                ))}
        </StreamCard>
    );
};
